import { render, staticRenderFns } from "./PraesidiumCardQuestionsAnswer.vue?vue&type=template&id=bbf6e8e2&"
import script from "./PraesidiumCardQuestionsAnswer.vue?vue&type=script&lang=ts&"
export * from "./PraesidiumCardQuestionsAnswer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
